import { Picture } from 'shared';

export interface SimplePictureProps {
	image: Image;
}

export const SimplePicture: React.FC<SimplePictureProps> = ({ image }) => {
	return <Picture {...image} />;
};
